export default "__VITE_ASSET__c3a0f378__"